module.exports = __webpack_public_path__ + "static/media/VectorLogoAtenea.d4c95e94.svg";